import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=22fed436&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22fed436')) {
      api.createRecord('22fed436', component.options)
    } else {
      api.reload('22fed436', component.options)
    }
    module.hot.accept("./Menu.vue?vue&type=template&id=22fed436&", function () {
      api.rerender('22fed436', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/admin/Menu.vue"
export default component.exports